<template>
  <div>
    <div v-if="edit">
      <v-row no-gutters>
        <v-text-field
          ref="name"
          v-model="title"
          @keyup.enter="
            edit = false;
            $emit('update');
          "
          autofocus
          filled
          dense
          :rules="[rules.required]"
          required
        >
          <!-- <template v-slot:append>
          <a-btn
            class="ml-2"
            x-small
            color="primaryDark"
            width="24"
            min-width="24"
            @click.prevent="onSaveTextFieldValue"
          >
            <v-icon size="16" color="#ffffff"> mdi-check</v-icon>
          </a-btn>
          <a-btn
            class="ml-2"
            x-small
            color="secondary"
            width="24"
            min-width="24"
            @click.prevent="title = ''"
          >
            <v-icon size="16" color="neutralGray1"> mdi-close</v-icon>
          </a-btn>
        </template> -->
        </v-text-field>
      </v-row>
      <v-row no-gutters>
        <v-col cols="12" sm="12" class="text-right">
          <a-btn
            class="ml-2"
            x-small
            color="primaryDark"
            width="24"
            min-width="24"
            @click.prevent="onSaveTextFieldValue"
          >
            <v-icon size="16" color="#ffffff"> mdi-check</v-icon>
          </a-btn>
          <a-btn
            class="ml-2"
            x-small
            color="secondary"
            width="24"
            min-width="24"
            @click.prevent="title = ''"
          >
            <v-icon size="16" color="neutralGray1"> mdi-close</v-icon>
          </a-btn>
        </v-col>
      </v-row>
    </div>
    <div v-else>
      <v-icon size="18" color="darkCharcoal" class="mr-2"
        >mdi-map-marker-radius</v-icon
      >
      <span class="label-m">{{ title }} </span>
      <a-btn
        class="ml-2"
        x-small
        color="secondary"
        width="24"
        min-width="24"
        @click="edit = true"
      >
        <v-icon size="16" color="neutralGray1"> mdi-pencil</v-icon>
      </a-btn>
    </div>
    <!-- <v-row>
      <v-tabs class="a-tabs">
        <v-tab>Item One</v-tab>
        <v-tab>Item Two</v-tab>
        <v-tab>Item Three</v-tab>
      </v-tabs>
    </v-row> -->
  </div>
</template>

<script>
import ATextField from "../components/ATextField.vue";
export default {
  components: { ATextField },
  name: "TabSample",
  data() {
    return {
      edit: false,
      title: "hitesh",
      rules: {
        required: (value) => !!value || "Field required.",
      },
    };
  },
  methods: {
    onSaveTextFieldValue() {
      if (this.title) {
        this.edit = false;
      }
      this.$refs["name"].validate(true);
    },
  },
};
</script>

<style  scoped>
.v-text-field.v-text-field--enclosed /deep/ .v-text-field__details {
  margin-bottom: 0px !important;
}

</style>>